import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	title: {
		id: 'eoc.heartbeats.switch-modal.title.no-translate',
		defaultMessage: 'Turn off heartbeat?',
		description: 'The text will be displayed in the switch modal title',
	},
	description: {
		id: 'eoc.heartbeats.switch-modal.description.no-translate',
		defaultMessage:
			'We’ll stop monitoring the connectivity of your system and won’t send an alert for this heartbeat. You can turn it back on when required.',
		description: 'The text will be displayed in the switch modal body description',
	},
	turnOff: {
		id: 'eoc.heartbeats.extra-property.switch-modal.switch-button.no-translate',
		defaultMessage: 'Turn off',
		description: 'The text will be displayed in the switch modal footer for turn-off button.',
	},
});

export default messages;
